const dateString = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

export const issueScope = (params: URLSearchParams, now = new Date()) => {
  const monthStart = dateString(new Date(now.getFullYear(), now.getMonth(), 1));
  const monthEnd = dateString(
    new Date(now.getFullYear(), now.getMonth() + 1, 0),
  );
  const from = params.get("issues_from") ?? monthStart;
  const to = params.get("issues_to") ?? monthEnd;
  const explicitView = params.get("issues_view");
  const periodView =
    explicitView === "period" ||
    (explicitView !== "attention" &&
      (params.has("issues_date_range") ||
        from !== monthStart ||
        to !== monthEnd));
  return { from, to, periodView };
};
